import React, { Component } from 'react';
import i18n from 'react-intl-universal';
import { connect } from 'react-redux';
import Modal from '../Modal/';
import styles from './PNAgreeModal.scss';
import Ajax from '../../utils/ajax';
import Message from '../Message/Message';
import NestLoading from '../Loading/NestLoading';
import { setUser } from '../../actions/UserAction';

@connect(
  state => ({
  }),
  dispatch => ({
    setUser: data => dispatch(setUser(data)),
  }),
)
export default class PNAgreeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
      // isSubmitting: false,
      contentLoading: true,
    };
    Ajax.getPayNoteAgreement().then(({ data = '' }) => {
      let content;
      data.replace(/\n/g, '').replace(/<\/head>(.*)<\/html>/ig, (match, $1) => {
        content = $1 || '';
      });
      this.setState({
        content,
        contentLoading: false,
      });
    }).catch((res) => {});
  }

  onModalCancelBtnClick = () => {
    const { onModalCancelBtnClick } = this.props;
    onModalCancelBtnClick();
  }
  render() {
    const { visible } = this.props;
    const { content, contentLoading } = this.state;
    return (
      <Modal
        visible={visible}
        modalClassName={styles['modal']}
        width={580}
        showFooter={false}
        isMiddle
        title={i18n.get('pay-note.agree-title')}
        onCancel={this.onModalCancelBtnClick}
      >
        {
          contentLoading && <NestLoading/>
        }
        <div
          className={styles['modal-body']}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PNAgreeModal/PNAgreeModal.js